export class ColorData {
    splash_cutom_bg_color:string=null;
  }


// WEBPACK FOOTER //
// /app/src/app/core/models/color-data.ts